/*
Documentation

this page shows all assigned_automations inside an automations
contacts can then be removed from being assigned to the automation
or added to the automation

*/

import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Card, CardHeader, CardTitle, Modal, CardBody} from 'reactstrap';
import ContactSearch from 'components/system/migrated/ContactSearch';

import Circle from 'components/markup/loading/Circle';
import renderName from 'utils/renderName'
import paginationFactory from "react-bootstrap-table2-paginator";
import _automations from '_functions/automations';
import moment from 'moment';

const { SearchBar } = Search;

class AutomationsAll extends React.Component {

    state = {
        showAddModal: false,
        automations_assigned: null,
        automation: null
    }

    columns = [
        {
            dataField: "name",
            text: "Name",
            formatter: (cell, row) => <Link to={`/automations/automations/view/${row._id}`} className="text-capitalize font-weight-bold">{renderName(row.contact)}</Link>
        },
        {
            dataField: "automation",
            text: "Automation",
            formatter: (cell, row) => row.automation ? row.automation.name : 'Not Found'
        },
        {
            dataField: "next_run_date",
            text: "Next Run Date",
            formatter: (cell, row) => moment.unix(row.next_run_date).format('MMM Do, YYYY - h:mm A')
        },
        {
            dataField: "created_at",
            text: "Next Sequence Task",
            formatter: (cell, row) => row.task_to_run ? row.task_to_run.order : 'N/A'
        },
        {
            dataField: "_id",
            text: "Actions",
            headerStyle: {textAlign: 'right'},
            formatter: (cell, row) => {
                return (
                    <div className="text-right">
                        <i className="fas fa-trash text-danger mr-3 cursor-pointer" onClick={() => this.onRemove(row)} />
                    </div>
                )
            }
        },
    ]

    pagination = paginationFactory({
        page: 1,
        sizePerPage: 25,
        alwaysShowAllBtns: true,
        showTotal: true,
        withFirstAndLast: true,
        sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
            <div className="dataTables_length" id="datatable-basic_length">
                <label>
                    Show{" "}
                    {
                    <select
                        value={currSizePerPage}
                        name="datatable-basic_length"
                        aria-controls="datatable-basic"
                        className="form-control form-control-sm"
                        onChange={e => onSizePerPageChange(e.target.value)}
                    >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    }{" "}
                    entries.
                </label>
            </div>
        )
    });

    onRemove = async (automation_assigned) => {

        await _automations.assigned.delete(automation_assigned._id)
        this.fetchData()

    }

    toggleAddModal = () => this.setState({showAddModal: !this.state.showAddModal, hasContact: false})
    onSelectContact = (contact) => this.setState({hasContact: contact})

    onAddContact = async (contact) => {

        const automation_id = this.props.match.params._id

        const task_to_run = await _automations.tasks.all(`?filter=automation__${automation_id}|order__1{number}`)

        if(task_to_run && task_to_run.data && task_to_run.data.length) {

            await _automations.assigned.create({
                contact: this.state.hasContact._id,
                task_to_run: task_to_run.data[0]._id,
                automation: automation_id
            })

            this.fetchData()
            this.toggleAddModal()

        }

    }

    onClear = async () => {

        await _automations.assigned.clear(this.props.match.params._id)
        this.fetchData()

    }

    fetchData = async () => {

        const automation_id = this.props.match.params._id

        const automations_assigned = await _automations.assigned.all(`?filter=automation__${automation_id}&show_all=true&populate=automation&sort=next_run_date__asc`)
        if(automations_assigned.success) this.setState({automations_assigned: automations_assigned.data})

        if(automation_id !== 'new') {

            const foundAutomation = this.props.automations.find(a => a._id === automation_id)

            if(foundAutomation) {

                this.setState({automation: foundAutomation})

            } else {

                this.setState({shouldRedirect: '/automations/automations/all'})

            }

        }

    }

    componentDidMount = async () => this.fetchData()

    render() {

        const { automations_assigned, hasContact, showAddModal, automation } = this.state

        return (
        <>

            <Helmet>
                <title>{`Contacts In Automation`}</title>
                <meta name="description" content="Tags" />
            </Helmet>

            <Container fluid >

                <DashHeaderOpen
                    title={<span>Contacts In Automation</span>}
                    actionComponent={(
                        <>
                        <button onClick={this.onClear} className="btn btn-danger">
                            <i className="fas fa-exclamation-triangle mr-2" /> Cancel Automation
                        </button>
                        <button onClick={this.toggleAddModal} className="btn btn-success">
                            <i className="fas fa-user-plus mr-2" /> Add Contact
                        </button>
                        </>
                    )}
                />

                <Card>

                    <CardHeader>
                        <CardTitle className="mb-0">{automation ? automation.name : null}</CardTitle>
                    </CardHeader>

                    {automations_assigned ? (
                        <ToolkitProvider
                            data={automations_assigned}
                            keyField="_id"
                            columns={this.columns}
                            search
                        >
                            {props => (
                                <>
                                <div
                                    id="datatable-basic_filter"
                                    className="dataTables_filter px-4 pb pt-3 pb-2"
                                    style={{width: '100%'}}
                                >
                                    <label>
                                        Search:
                                        <SearchBar
                                            className="form-control-sm"
                                            placeholder="Name, Email, Phone"
                                            {...props.searchProps}
                                        />
                                    </label>
                                </div>
                                <div className=" table-responsive table-vertical-align table-not-fixed">
                                    <BootstrapTable
                                        pagination={this.pagination}
                                        {...props.baseProps}
                                        bootstrap4={true}
                                        bordered={false}
                                    />
                                </div>
                                </>
                            )}
                        </ToolkitProvider>
                    ) : (
                        <CardBody>
                            <Circle />
                        </CardBody>
                    )}

                </Card>

                <Modal
                    className="modal-dialog-centered"
                    isOpen={showAddModal}
                    toggle={() => this.toggleAddModal()}
                    size="md"
                >
                    <div className="modal-header">

                        <h5 className="modal-title" id="exampleModalLabel"> Add Contact To Automation </h5>

                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleAddModal()}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>

                    </div>

                    {hasContact ? (

                        <>
                            <div className="modal-body"> Add {renderName(hasContact)} to this automation? </div>
                            <div className="modal-footer text-right"> <button onClick={this.onAddContact} className="btn btn-success">Add Contact</button> </div>
                        </>

                    ) : (
                        <div className="modal-body"> <ContactSearch onSelect={this.onSelectContact} /> </div>
                    )}

                </Modal>

            </Container>

            </>
        );
    }
}

const mapStateToProps = state => {

    return {
        automations: state.automations.automations,
    };
};

export default connect(mapStateToProps, '')(AutomationsAll);
